<div class="page-container forgotPasswordPart">

    <div class="metltv-background">
        <img class="login-logo forgotPasswordLogo" (click)="router.navigate(['/'])" src="assets/img/metltvlogo.svg">
    </div>
    <div id="forgot-pass-form-container">
        <form [formGroup]="forgotPassForm">
            <h3>Forgot Password</h3>
            <h4>Enter your email</h4>
            <input placeholder="Enter email" formControlName="email">
            <span class="error" *ngIf="forgotPassForm.get('email').hasError('required') && isSubmitted">
                Please write your email</span>
            <span class="error" *ngIf="forgotPassForm.get('email').hasError('patternInvalid') && isSubmitted">
                E-mail is invalid
            </span>

            <div class="actions">
                <button (click)="sendEmail()">Submit</button>
                <mat-spinner [diameter]="15" *ngIf="loader.formProcessing"></mat-spinner>
            </div>
        </form>
    </div>
</div>
